"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const status_codes_1 = require("@biorad-lsg-tsc/status-codes");
const http_status_codes_1 = require("http-status-codes");
const user_permissions_1 = __importDefault(require("./user-permissions"));
class TokenValidation {
    static async validatePermissionsInHeaders(permissions, headers, userId, tenantId) {
        const userPermissions = await user_permissions_1.default.getUserPermissions(headers);
        const userCognitoId = userPermissions?.userCognitoId;
        if (!TokenValidation.validateRequestUserIdInToken(userCognitoId, userId))
            throw new status_codes_1.StatusCodeError(http_status_codes_1.StatusCodes.UNAUTHORIZED, `user ${userId} is unauthorized`);
        await TokenValidation.validatePermissions(permissions, userPermissions, tenantId);
    }
    static validateRequestUserIdInToken(userCognitoId, userId) {
        if (userCognitoId && userId)
            return userCognitoId === userId;
        return false;
    }
    static async validateRequestTenantInToken(tenantId, userPermissions) {
        const accessTokenTenantId = userPermissions.tenantId;
        if (accessTokenTenantId !== tenantId) {
            console.log(`validateTenantToken ERROR: TenantId in token: ${accessTokenTenantId}, TenantId in request: ${tenantId}`);
            throw new status_codes_1.BadRequestError(`TenantId in header does not match the request`);
        }
    }
    static validateTokenExpiration(userPermissions) {
        const accessTokenExpirationTime = userPermissions.getKey('exp');
        const currentTime = Math.floor(Date.now() / 1000);
        if (!accessTokenExpirationTime || currentTime >= accessTokenExpirationTime) {
            console.log(`validateTokenExpiration ERROR: Token expired`);
            throw new status_codes_1.StatusCodeError(http_status_codes_1.StatusCodes.UNAUTHORIZED, 'Token expired');
        }
    }
    static async validatePermissions(permissions, userPermissions, tenantId) {
        await TokenValidation.validateRequestTenantInToken(tenantId, userPermissions);
        TokenValidation.validateTokenExpiration(userPermissions);
        if (!userPermissions.hasPermissions(permissions)) {
            console.log(`User ${userPermissions.id} does not have permissions. ${JSON.stringify(permissions)}`);
            throw new status_codes_1.StatusCodeError(http_status_codes_1.StatusCodes.FORBIDDEN, 'insufficient permissions');
        }
    }
}
exports.default = TokenValidation;
